import { cancelIfLate, createJSONRequest } from './create-request'
import querify from '../util/querify'

export const fetchGroup = (group, filters) => createJSONRequest({
  url: `/api/actors?group=${group}&${querify(filters)}`,
  method: 'GET'
})

export const getTopCities = (filters) => createJSONRequest({
  url: `/api/actors?group=cities&${querify(filters)}`,
  method: 'GET'
})

export const getTypes = (filters) => createJSONRequest({
  url: `/api/actors?group=type&${querify(filters)}`,
  method: 'GET'
})

export const getCategories = (filters) => createJSONRequest({
  url: `/api/actors?group=category&${querify(filters)}`,
  method: 'GET'
})

export const getFoundingHistogram = (filters) => createJSONRequest({
  url: `/api/actors?group=histogram&${querify(filters)}`,
  method: 'GET'
})

export const getFundingHistogram = (filters) => createJSONRequest({
  url: `/api/actors?group=funding&${querify(filters)}`,
  method: 'GET'
})

export const getStage = (filters) => createJSONRequest({
  url: `/api/actors?group=stage&${querify(filters)}`,
  method: 'GET'
})

export const getAccelerators = (filters) => createJSONRequest({
  url: `/api/actors?group=accelerator&${querify(filters)}`,
  method: 'GET'
})

export const getFinancials = (filters, field) => createJSONRequest({
  url: `/api/actors?group=financials&${querify(Object.assign({}, filters, { field }))}`,
  method: 'GET'
})

export const getCompletion = (filters) => createJSONRequest({
  url: `/api/actors?group=completion`,
  method: 'GET'
})

export const fetchChart = (type, filters) => createJSONRequest({
  url: `/api/charts/${type}?${querify(filters)}`,
  method: 'GET'
})

export const fetchCharts = (filters) => createJSONRequest({
  url: `/api/charts?${querify(filters)}`,
  method: 'GET'
})

export const updateCharts = data => createJSONRequest({
  url: `/api/charts`,
  data
})

export const fetchAnalytics = (filters) => createJSONRequest({
  url: `/api/charts?chartType=analytics&${querify(filters)}`,
  method: 'GET'
})

/**
 * The dashboard analytic calls
 */
export const fetchEconomicReadinessKPIs = cancelIfLate((filters) => createJSONRequest({
  url: `/api/economic-readiness/kpis?${querify(filters)}`,
  method: 'GET'
}))

export const fetchEconomicReadinessStatusHistogram = cancelIfLate((filters) => createJSONRequest({
  url: `/api/economic-readiness/status-histogram?${querify(filters)}`,
  method: 'GET'
}))

export const fetchEconomicReadinessFundingHistogram = cancelIfLate((filters) => createJSONRequest({
  url: `/api/economic-readiness/funding-histogram?${querify(filters)}`,
  method: 'GET'
}))

export const fetchEconomicReadinessFundingRoundTypeHistogram = cancelIfLate((filters) => createJSONRequest({
  url: `/api/economic-readiness/funding-round-type-histogram?${querify(filters)}`,
  method: 'GET'
}))

export const fetchFundingAndGrantRounds = cancelIfLate((filters) => createJSONRequest({
  url: `/api/economic-readiness/funding-grant-rounds?${querify(filters)}`,
  method: 'GET'
}))

export const fetchEconomicReadinessRevenueHistogram = cancelIfLate((filters) => createJSONRequest({
  url: `/api/economic-readiness/revenue-histogram?${querify(filters)}`,
  method: 'GET'
}))

export const fetchEconomicReadinessDeclaredRevenueHistogram = cancelIfLate((filters) => createJSONRequest({
  url: `/api/economic-readiness/declared-revenue-histogram?${querify(filters)}`,
  method: 'GET'
}))

export const fetchEconomicReadinessEmployeeHistogram = cancelIfLate((filters) => createJSONRequest({
  url: `/api/economic-readiness/employee-histogram?${querify(filters)}`,
  method: 'GET'
}))

export const fetchEconomicReadinessDeclaredEmployeeHistogram = cancelIfLate((filters) => createJSONRequest({
  url: `/api/economic-readiness/declared-employee-histogram?${querify(filters)}`,
  method: 'GET'
}))

export const fetchEconomicReadinessActiveActorsHistogram = cancelIfLate((filters) => createJSONRequest({
  url: `/api/economic-readiness/active-actors-histogram?${querify(filters)}`,
  method: 'GET'
}))
